<template>
  <div class="card tweet-card" :class="{ miniView }">
    <div class="card-content">
      <div class="media">
        <tweet-media-left v-if="!miniView" :show-line-down="showLineDown" :show-line-up="showLineUp">
          <profile-pic v-if="!collapsed" :user="data.user"/>
        </tweet-media-left>
        <div class="media-content">
          <b-icon v-if="showTwitterLogo" size="is-large" type="is-info" pack="fab" icon="twitter"
                  class="is-pulled-right"></b-icon>
          <a v-if="showDelete" class="delete" @click="$emit('clear')"></a>
          <tweet-content :data="data" :mini-view="miniView || collapsed" :collapse-content="collapsed" :clickable="clickable"/>
          <div v-if="!collapsed">
            <tweet-media v-if="data.media && data.media.length > 0" :media="data.media"/>
            <div v-if="data.quoted_status" class="mb-2">
              <tweet
                  :data="data.quoted_status"
                  :show-delete="false"
                  :mini-view="true" :clickable="clickable"
              />
            </div>
            <tweet-actions v-if="showTweetActions" :tweet="data"></tweet-actions>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import ProfilePic from "../ProfilePic"
import TweetMedia from "./TweetMedia";
import TweetContent from "./TweetContent";
import TweetActions from "./TweetActions";
import TweetMediaLeft from "../TweetMediaLeft";

export default {
  name: 'Tweet',
  components: {TweetMediaLeft, ProfilePic, TweetActions, TweetContent, TweetMedia },
  props: {
    data: {},
    showLineDown: {
      type: Boolean,
      default: false
    },
    showLineUp: {
      type: Boolean,
      default: false
    },
    showDelete: {
      type: Boolean,
      default: false
    },
    showMedia: {
      type: Boolean,
      default: true,
    },
    showTweetActions: {
      type: Boolean,
      default: false
    },
    miniView: {
      type: Boolean,
      default: false
    },
    showTwitterLogo: {
      type: Boolean,
      default: false
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
    clickable: {
      type: Boolean,
      default: true
    }
  }
}
</script>
<style lang="scss" scoped>

.media-content {
  min-width: 0; // this is needed so tweet-content break-word works
}

.card-content {
  padding: 0;
}

.card.miniView {
  .card-content {
    padding: 0.75rem;
  }
}


.delete {
  opacity: 0.5;
  margin: 1rem 1rem 0 0;

  &:hover {
    opacity: 1;
  }
}

</style>
